// Inline [n] citation markers (feature 2). The backend numbers every source
// (citation_id) and the answer cites them as "[n]". Markers that name an
// existing source become a small clickable superscript; anything else (an
// invented number, a markdown link "[1](…)", a reference "[1]: …", code)
// is left exactly as written.

export const CITE_CLASS = "cite-ref";

const MARKER = /\[(\d+)\](?![(:])/g;
// Fenced/inline code and math are never touched.
const PROTECTED = /(```[\s\S]*?```|`[^`\n]*`|\$\$[\s\S]*?\$\$|\$[^$\n]*\$)/g;

export function citationIds(sources) {
  return new Set(
    (sources || []).map((s) => s && s.citation_id).filter((id) => Number.isInteger(id)),
  );
}

export function linkCitations(content, sources) {
  const ids = citationIds(sources);
  if (!content || ids.size === 0) return content;
  return content
    .split(PROTECTED)
    .map((part, i) =>
      i % 2 === 1
        ? part
        : part.replace(MARKER, (match, n) =>
            ids.has(Number(n)) ? `<sup class="${CITE_CLASS}">[${n}]</sup>` : match,
          ),
    )
    .join("");
}

// The citation number of a clicked marker element, or null.
export function citationFromEvent(event) {
  const el = event.target && event.target.closest && event.target.closest(`sup.${CITE_CLASS}`);
  if (!el) return null;
  const m = /^\[(\d+)\]$/.exec((el.textContent || "").trim());
  return m ? Number(m[1]) : null;
}
